import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import { Provider } from 'react-redux';
// import { store } from './Store/Store';
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./Store/Store";
import { RecoilRoot } from "recoil";
import { ModalProvider } from "./Admin/Components/Reactportal/ModalContext";
import { KeyHubProvider } from "react-keyhub";
import { myShortcuts } from "./Shortcuts/myShortcuts";
const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}
const root = ReactDOM.createRoot(rootElement);
root.render(
  <KeyHubProvider shortcuts={myShortcuts}>
    <RecoilRoot>
      <BrowserRouter>
        <Provider store={store}>
          <ModalProvider>
            <App />
          </ModalProvider>
        </Provider>
      </BrowserRouter>
    </RecoilRoot>
  </KeyHubProvider>
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
